import React from "react";
import MuiTableBody from "@mui/material/TableBody";
import PropTypes from "prop-types";

/**
 * TableBody component wrapper for table body content.
 * Wraps Material-UI TableBody with theme integration.
 * 
 * @component
 * @example
 * <TableBody>
 *   <TableRow>
 *     <TableCell>Data</TableCell>
 *   </TableRow>
 * </TableBody>
 */
const TableBody = ({ children, ...props }) => {
  return <MuiTableBody {...props}>{children}</MuiTableBody>;
};

TableBody.propTypes = {
  /**
   * The content of the component, normally TableRow
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI TableBody behavior

export default TableBody;

